export default "__VITE_ASSET__5283923e__"